"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMinigames = void 0;
const lodash_1 = __importStar(require("lodash"));
const smap_1 = require("../smap");
const Picross_1 = require("../components/Picross");
const MemoryGame_1 = require("../components/MemoryGame");
const react_1 = require("react");
const minigamePrizes_1 = __importDefault(require("../content/minigamePrizes"));
const MinigamesRegistry = {
    Picross: Picross_1.Picross,
    Memory: MemoryGame_1.Memory,
};
function useMinigames() {
    const allGames = (0, smap_1.keys)(MinigamesRegistry);
    const [currentMinigame, setCurrentMinigame] = (0, react_1.useState)(null);
    function pickMinigameByItem(item) {
        const config = minigamePrizes_1.default.minigamePrizes[item];
        if (!config || config.length === 0)
            return null;
        const r = lodash_1.default.sampleSize(config, 1)[0];
        return r;
    }
    function getMiniGame(minigame) {
        if (minigame === null || minigame === undefined)
            return null;
        if (currentMinigame !== null) {
            return MinigamesRegistry[currentMinigame];
        }
        if (minigame === undefined) {
            minigame = allGames[(0, lodash_1.random)(0, allGames.length - 1)];
        }
        setCurrentMinigame(minigame);
        return MinigamesRegistry[minigame];
    }
    function resetMinigame() {
        setCurrentMinigame(null);
    }
    return {
        getMiniGame,
        resetMinigame,
        pickMinigameByItem,
    };
}
exports.useMinigames = useMinigames;
